import { render, staticRenderFns } from "./ProductDimensionsLength.vue?vue&type=template&id=746200fc&"
import script from "./ProductDimensionsLength.vue?vue&type=script&lang=ts&"
export * from "./ProductDimensionsLength.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports